import { render, staticRenderFns } from "./TagReach.vue?vue&type=template&id=40243d80"
import script from "./TagReach.vue?vue&type=script&lang=js"
export * from "./TagReach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports